import React from 'react';

function FaqCertification(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      width={52}
      height={52}
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect width={52} height={52} rx={4} fill='#DFD8F3' />
      <mask
        id='mask0_9879_72216'
        style={{
          maskType: 'alpha'
        }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={10}
        width={32}
        height={32}
      >
        <rect x={10} y={10} width={32} height={32} fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_9879_72216)'>
        <path
          d='M26.0015 11.1719C26.0403 11.1719 26.0774 11.1837 26.1099 11.2051L27.9683 12.4121C28.1467 12.5279 28.359 12.5809 28.5708 12.5596L30.2954 12.3906C30.6502 12.3558 30.9942 12.5249 31.1831 12.8281L32.0815 14.2656C32.1958 14.4489 32.3702 14.5881 32.5757 14.6572L34.2192 15.2148C34.5668 15.3332 34.813 15.6427 34.8511 16.0078L35.0298 17.7432C35.052 17.9606 35.1498 18.1632 35.3062 18.3164L36.4995 19.4863C36.7591 19.7412 36.8479 20.1238 36.728 20.4668L36.1616 22.085C36.0911 22.2872 36.0923 22.5067 36.1636 22.709L36.729 24.3018C36.8481 24.6376 36.7677 25.0131 36.52 25.2695L35.2827 26.5488C35.1407 26.6956 35.0506 26.8846 35.0259 27.0869L34.8101 28.8457C34.7664 29.2006 34.5252 29.4998 34.187 29.6182L32.5776 30.1787C32.3776 30.2486 32.2068 30.3839 32.0933 30.5625L31.1489 32.0508C30.9568 32.3532 30.6088 32.5193 30.2524 32.4805L28.5542 32.293C28.3455 32.27 28.1342 32.3176 27.9556 32.4287L26.5181 33.3203C26.2156 33.5076 25.8332 33.5079 25.5308 33.3213L24.0864 32.4326C23.9126 32.3255 23.7076 32.2781 23.5044 32.2979L21.7056 32.4697C21.3508 32.5038 21.008 32.3338 20.8198 32.0322L19.9048 30.5654C19.7929 30.3855 19.6224 30.2494 19.4233 30.1787L17.7847 29.5957C17.4464 29.4758 17.2052 29.1719 17.1655 28.8154L16.9722 27.0947C16.9492 26.8892 16.8587 26.6961 16.7144 26.5469L15.481 25.2705C15.2334 25.0141 15.152 24.6394 15.271 24.3037L15.8374 22.7109C15.9089 22.5093 15.91 22.2884 15.8394 22.0859L15.2739 20.4668C15.154 20.123 15.2428 19.7412 15.5024 19.4863L16.6948 18.3164C16.8512 18.1632 16.9489 17.9607 16.9712 17.7432L17.1509 16.0078C17.189 15.6426 17.435 15.3331 17.7827 15.2148L19.4253 14.6572C19.6301 14.5874 19.8053 14.449 19.9204 14.2656L20.8179 12.8281C21.0068 12.5256 21.3508 12.3565 21.7065 12.3906L23.4302 12.5596C23.6422 12.5802 23.855 12.528 24.0337 12.4121L25.8921 11.2051C25.9246 11.1837 25.9626 11.1719 26.0015 11.1719ZM26.0015 15.2695C22.0703 15.2695 18.8833 18.4629 18.8833 22.4014C18.8834 26.3398 22.0704 29.5332 26.0015 29.5332C29.9324 29.533 33.1186 26.3397 33.1187 22.4014C33.1187 18.463 29.9324 15.2697 26.0015 15.2695Z'
          fill='#AF9DE0'
        />
        <path
          d='M19.523 38.6599C19.4473 38.5982 19.351 38.5673 19.2533 38.5725L15.9446 38.7437C15.6683 38.7577 15.4625 38.4916 15.547 38.2278L17.4799 32.1668C17.549 31.9508 17.7849 31.8361 17.9973 31.9162C18.0803 31.9471 18.1501 32.0051 18.1957 32.0808L19.484 34.1974C19.5641 34.329 19.7126 34.4017 19.8655 34.3856L22.4113 34.1063C22.5009 34.0967 22.5906 34.1173 22.667 34.1658L24.1155 35.0852C24.2662 35.1808 24.3346 35.3652 24.2824 35.5357L22.692 40.6413C22.6251 40.8559 22.3627 40.936 22.1871 40.7956L19.523 38.6599Z'
          fill='#AF9DE0'
        />
        <path
          d='M27.6996 35.5692C27.6467 35.3994 27.7136 35.2149 27.8628 35.1187L29.3319 34.1677C29.4083 34.1184 29.4994 34.0964 29.5906 34.1067L32.1341 34.3852C32.287 34.4021 32.4355 34.3286 32.5156 34.1971L33.8068 32.0753C33.8509 32.0033 33.9171 31.9482 33.9957 31.9188L34.0023 31.9166C34.2162 31.8357 34.4536 31.9504 34.5219 32.1672C34.8997 33.3548 36.0197 36.8685 36.4533 38.2274C36.5371 38.4913 36.3321 38.7573 36.055 38.7433L32.7463 38.5721C32.6486 38.5669 32.5523 38.5986 32.4766 38.6596L29.8118 40.7967C29.6369 40.9371 29.3752 40.8577 29.3076 40.6439L27.6996 35.5692Z'
          fill='#AF9DE0'
        />
        <path
          d='M26.0004 26.7711C28.4082 26.7711 30.3602 24.8155 30.3602 22.4031C30.3602 19.9908 28.4082 18.0352 26.0004 18.0352C23.5926 18.0352 21.6406 19.9908 21.6406 22.4031C21.6406 24.8155 23.5926 26.7711 26.0004 26.7711Z'
          fill='#AF9DE0'
        />
      </g>
    </svg>
  );
}

FaqCertification.displayName = 'FaqCertification';

export default FaqCertification;
